module.exports = __webpack_public_path__ + "img/certif.259d7b21.svg";